import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from './store';
import {BootstrapVue, BootstrapVueIcons} from 'bootstrap-vue'
import axios from "axios";
import VeeValidate from "vee-validate";
import VueAceEditor from "vue2-ace-editor";
import VueClipboard from 'vue-clipboard2'
import VueResize from 'vue-resize'
// Styles
import './custom.scss'
import 'vue-resize/dist/vue-resize.css'

window.$ = require("jquery");
window.jQuery = require("jquery");

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)
Vue.component("ace-editor", VueAceEditor);

Vue.config.productionTip = false;

Vue.prototype.$variants = [
    'transparent',
    'white',
    'light',
    'dark',
    'primary',
    'secondary',
    'success',
    'danger',
    'warning',
    'info',
];

Vue.use(VeeValidate, {
    inject: true,
    fieldsBagName: "veeFields",
    errorBagName: "veeErrors"
});

Vue.use(VueClipboard)

Vue.use(VueResize)

let reqOne = axios.get("/OppPortal/api/v1/opp/applicationSettings");
let reqTwo = axios.get("/OppPortal/api/v1/opp/enums");

axios.all([reqOne, reqTwo])
    .then(axios.spread((...res) => {
        Vue.prototype.$appSettings = res[0].data;
        Vue.prototype.$enums = res[1].data;
        new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount("#app");
    }))
    .catch((error) => {
        console.log(error);
        new Vue({
            router,
            store,
            render: h => h(App)
        }).$mount("#app");
    });